import LvCheckbox from './Checkbox.vue';
export default LvCheckbox;
